import O1HD from "../../../engines/gameEngine";
import { SPEND_MODE_EVENT } from "../config/SpendEnum";
import {NpcEventRel, SpendModeAccountBookItemIMap, SpendModeDataI} from "../config/SpendInterface";
import getOneSpendEventById, {getRandomStartEvent, getStartOnloadEvent} from "../config/SpendEventConfig";
import spendMode from "../spendMode";

export default class spendGameManager{

    constructor( spendMode : spendMode ){
        this.mGameLayer = spendMode;
        this.loadGameData();
        O1HD.on("spendGameManager.addOrUpdateEvent" , this.addOrUpdateEvent , this );
    }

    mGameLayer : spendMode;
    //数据存储的key
    private spend_Mode_Data_Save_Key:string = "spend-mode-data-save-key";
    //初始天数
    private initDays:number = 0;
    //初始的钱
    private initCoin:number = 10000000;
    //初始目标钱
    private initTargetMoney:number = 1000000;
    //初始的花费钱
    private initCostMoney:number = 0;
    //当前的事件列表
    private initCurrentEvents:any[] = [];
    //账本
    private initAccountBook: SpendModeAccountBookItemIMap = new SpendModeAccountBookItemIMap();
    //npc初始投资事件
    private npcIntInvestmentArray:number[] = [];
    //房子升级过的NPC数组
    private initGradeNpcArray:string[] = [];
    //当天是否展示日志
    private initLogShowFlag : boolean = false;
    //所需要花的钱
    readonly NEED_COST_COINS_ARRAY : number[] = [1000000,1000000,1000000,1000000,1000000,1000000,1000000];

    //游戏数据
    private _gameData:SpendModeDataI = {
        _gameDays : this.initDays,
        _coin : this.initCoin,
        _currentDayTargetMoney : this.initTargetMoney,
        _currentCostMoney : this.initCostMoney,
        _currentEvents:this.initCurrentEvents,
        _account_book:this.initAccountBook,
        _npcGradeArray:this.initGradeNpcArray,
        _logShowFlag : this.initLogShowFlag,
    };

    //加载游戏数据
    loadGameData(){
        let dataStr:string = O1HD.getServices().localStorageSrv.getStorage(this.spend_Mode_Data_Save_Key) || JSON.stringify(this._gameData);
        let data = JSON.parse(dataStr);
        this.setGameData(data,false);
        this.loadAllNpc();
        // this._gameData = JSON.parse(dataStr);
    }
    //设置游戏数据
    setGameData(data:SpendModeDataI,isPlus:boolean = false,node:cc.Node = O1HD.Canvas()){
        for(let key in data){
            let k = data[key];
            if(k != null){
                if(k instanceof Array){
                    if(isPlus){
                        this._gameData[key] = this._gameData[key].concat(k);
                    }else{
                        this._gameData[key] = [].concat(k);
                    }
                }else {
                    if(isPlus){
                        this._gameData[key] += k;
                        if(key == "_coin" && node && node.isValid){
                            if(k > 0){
                                O1HD.getManagers().gameMgr.ChaoPiaoAni(node,O1HD.getManagers().gameMgr.chaoPiaoInitPos);
                            }
                        }
                    }else{
                        this._gameData[key] = k;
                    }
                }
            }
        }
        this.writeGameData();
    }
    //获取游戏数据
    getGameData(){
        return this._gameData;
    }
    //写入游戏数据
    writeGameData(){
        O1HD.getServices().localStorageSrv.setStorage(this.spend_Mode_Data_Save_Key,JSON.stringify(this._gameData));
    }

    resetGameData(){
        this._gameData = {
            _gameDays : this.initDays,
            _coin : this.initCoin,
            _currentDayTargetMoney : this.initTargetMoney,
            _currentCostMoney : this.initCostMoney,
            _currentEvents:this.initCurrentEvents,
            _account_book:this.initAccountBook,
            _npcGradeArray:this.initGradeNpcArray
        };
        this.writeGameData();
    }

    resetManage(){

    }



    /**
     * 判断是否可以切入下一天
     */
    checkCanNextDay(){
        return this._gameData._currentCostMoney >= this._gameData._currentDayTargetMoney;
    }

    /**
     * 跳入下一天
     */
    jumpToNextDay(){
        // 切换到下一天
        //设置游戏天数到下一天
        this.setGameData({ _gameDays : 1 },true );
        this.mGameLayer.daysLb.string = `第${(this._gameData._gameDays+1)}天`;
        //重置日志开关
        this.getGameData()._currentCostMoney = 0;
        this.getGameData()._currentDayTargetMoney = this.NEED_COST_COINS_ARRAY[this._gameData._gameDays];
        this.getGameData()._currentEvents.forEach( ( item , index , dataList )=>{
            item.todayInvestCoins = 0;
        });
        this.setGameData({ _logShowFlag : true } );
        //展示今天的花费报表
        this.mGameLayer.showLog();
        //场景中所有可以交互的物体全部初始化
        O1HD.emit(SPEND_MODE_EVENT.SPEND_OBJ_INIT);
        // 加载配置 启动信息
        this.loadEventConfig();
    }

    /**
     * 加载当天 启动任务
     */
    loadEventConfig(){
        //加载当天的启动 配置信息
        let eventArray = getStartOnloadEvent( this._gameData._gameDays );
        for ( let event of eventArray ) {
            let findItem = this._gameData._currentEvents.find(( item ,index ,dataList )=>{
                return item.npc == event.belongNpc;
            });
            if ( !findItem ) {
                //添加事件
                O1HD.emit("spendGameManager.addOrUpdateEvent", event.belongNpc , event.id , 0 , 0 );
            }
        }
    }

    /**
     * 添加 或者更新 一个事件
     * @param npc npc
     * @param nextEventId 事件id
     * @param investCoins 投资金额
     * @param changeCoins 改变金额 < 0 亏损金额 > 0 投资金额
     */
    addOrUpdateEvent( npc : string , nextEventId : string , investCoins : number , changeCoins : number ){
        let npcGameItem = this._gameData._currentEvents.find(( item ,index, dataList )=>{
            return item.npc == npc;
        });
        let eventInfo = getOneSpendEventById( nextEventId );
        if ( npcGameItem ) {
            if ( !nextEventId ) {
                //事件的完结
                npcGameItem.eventId = getRandomStartEvent( npc,this._gameData._gameDays ).id;
                npcGameItem.remainCoins = 0;
                npcGameItem.investCoins = 0;
                npcGameItem.todayInvestCoins = 1;
            }else{
                // 更新
                npcGameItem.eventId = nextEventId;
                npcGameItem.remainCoins += changeCoins;
                npcGameItem.remainCoins = npcGameItem.remainCoins < 0 ? 0 : npcGameItem.remainCoins;
                // triggerDays : eventInfo.triggerDays ? this._gameData._gameDays + 1 + eventInfo.triggerDays : null,
                if ( investCoins < 0 ) {
                    npcGameItem.investCoins -= investCoins;
                    npcGameItem.todayInvestCoins -= investCoins;
                }
            }
        }else{
            //
            this.mGameLayer.addOneNpc(npc);
            let addNpcEventRel : NpcEventRel = {
                npc : npc ,
                eventId : nextEventId ,
                triggerDays : eventInfo.triggerDays ? this._gameData._gameDays + 1 + eventInfo.triggerDays : null ,
                investCoins : investCoins,
                remainCoins : investCoins,
                todayInvestCoins : investCoins,
            }
            this._gameData._currentEvents.push( addNpcEventRel );
        }
        this.setGameData({_coin : investCoins} , true );
    }

    checkEventCanTrigger(){

    }


    loadAllNpc(){
        let npcs = this.getGameData()._currentEvents;
        for(let i =0;i<npcs.length;i++){
            let npc = npcs[i];
            let npcName:string = npc.npc;
            this.mGameLayer.addOneNpc(npcName);
        }
    }

}
